import { Feature, Features } from '@ardoq/api-types';
import { FeatureContext } from './types';

export const getEmptyFeatureContext = (): FeatureContext => ({
  isOrgAdmin: false,
  isArdoqEmployee: false,
  isTrial: false,
  features: {},
});

export const hasFeature = (
  {
    isOrgAdmin,
    isArdoqEmployee,
    isTrial,
    features,
    devOverrides,
  }: FeatureContext,
  feature: Feature
) => {
  if (feature.requiresOrgAdmin && !isOrgAdmin) {
    return false;
  }
  if (feature.requiresArdoqEmployee && !isArdoqEmployee) {
    return false;
  }
  if (!feature.persistedId) {
    return false;
  }

  // Development overrides
  if (devOverrides && feature.persistedId in devOverrides) {
    return Boolean(devOverrides[feature.persistedId]);
  }

  return Boolean(
    features[feature.persistedId] || (feature.isEnabledForTrial && isTrial)
  );
};

export const hasScenarioFeature = (featureContext: FeatureContext) => {
  if (hasFeature(featureContext, Features.DISABLE_WORKSPACE_MODE)) {
    return false;
  }
  if (hasFeature(featureContext, Features.USE_NEW_PRICING_MODULES)) {
    return (
      hasFeature(featureContext, Features.TRANSFORMATION_MODULE) &&
      hasFeature(featureContext, Features.SCENARIOS_BETA)
    );
  }

  return hasFeature(featureContext, Features.SCENARIOS_BETA);
};

export const hasAIGeneratedScenariosFeature = (
  featureContext: FeatureContext
) => hasFeature(featureContext, Features.AI_VALUE_STREAMS);

export const hasScenarioAnalyticsFeature = (featureContext: FeatureContext) =>
  hasScenarioFeature(featureContext) &&
  hasFeature(featureContext, Features.SCENARIO_ANALYTICS);
